import { keyframes } from "styled-components";

export const CHECK_ANIMATION_MS = 1000;

export const faireAcademyFadeIn = keyframes({
  "0%": { opacity: "0" },
  "100%": { opacity: "1" },
});
